module.exports = __webpack_public_path__ + "c31765d25bc851f1fa25051c02bbe638.svg";